function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1984(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18.83,
    height: 9.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.6616666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 4.985
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.97,
    width: 18.83,
    height: 12.48,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.782857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 16.21
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 22.45,
    width: 18.83,
    height: 12.73,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2730000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 28.814999999999998
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 35.17,
    width: 18.83,
    height: 13,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 41.67
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 48.18,
    width: 18.83,
    height: 13.72,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9600000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 55.04
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 61.9,
    width: 18.83,
    height: 14.91,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.485
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 69.355
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 76.81,
    width: 18.83,
    height: 16.77,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.09625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 85.19500000000001
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 93.58,
    width: 18.83,
    height: 17.14,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 102.15
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 110.72,
    width: 18.83,
    height: 20.03,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7659999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 120.735
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 130.75,
    width: 18.83,
    height: 21.8,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.138333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 141.65
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 152.55,
    width: 18.83,
    height: 23.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.138333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 164.22500000000002
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 175.9,
    width: 18.83,
    height: 23.56,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 187.68
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 199.46,
    width: 18.83,
    height: 26.35,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.138333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 212.63500000000002
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 225.81,
    width: 18.83,
    height: 27.05,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.35375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 239.335
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 252.86,
    width: 18.83,
    height: 27.17,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 266.445
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 280.02,
    width: 18.83,
    height: 27.47,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.138333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 293.755
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 307.5,
    width: 18.83,
    height: 28.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.7075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 321.54
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 335.57,
    width: 18.83,
    height: 28.28,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.35375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 349.71
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 363.85,
    width: 18.83,
    height: 28.81,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.138333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 378.255
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 392.66,
    width: 18.83,
    height: 30.98,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 408.15000000000003
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 423.64,
    width: 18.83,
    height: 32.77,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7659999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 440.025
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 456.41,
    width: 18.83,
    height: 33.31,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.138333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 473.06500000000005
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 489.72,
    width: 18.83,
    height: 33.75,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7659999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 506.595
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 523.47,
    width: 18.83,
    height: 33.94,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8829999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 540.44
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 557.41,
    width: 18.83,
    height: 34.38,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.138333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 574.6
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 591.79,
    width: 18.83,
    height: 35.63,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.138333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 609.605
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 627.41,
    width: 18.83,
    height: 36.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 645.53
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 663.66,
    width: 18.83,
    height: 36.34,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.35375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.415,
    y: 681.8299999999999
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.83,
    y: 0,
    width: 24.54,
    height: 28.2,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.505714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.099999999999998,
    y: 14.1
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.36,
    y: 0,
    width: 24.58,
    height: 28.2,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.511428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.65,
    y: 14.1
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.94,
    y: 0,
    width: 24.99,
    height: 28.2,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.165
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.435,
    y: 14.1
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.93,
    y: 0,
    width: 25.44,
    height: 28.2,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.65,
    y: 14.1
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.37,
    y: 0,
    width: 25.57,
    height: 28.2,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.114
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.155,
    y: 14.1
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.94,
    y: 0,
    width: 25.76,
    height: 28.2,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.293333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 156.82,
    y: 14.1
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 169.7,
    y: 0,
    width: 26.63,
    height: 28.2,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.32875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 183.015,
    y: 14.1
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.33,
    y: 0,
    width: 26.95,
    height: 28.2,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 209.805,
    y: 14.1
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.28,
    y: 0,
    width: 27.29,
    height: 28.2,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.458
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 236.925,
    y: 14.1
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 250.57,
    y: 0,
    width: 27.35,
    height: 28.2,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.470000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.245,
    y: 14.1
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.92,
    y: 0,
    width: 28.37,
    height: 28.2,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 292.105,
    y: 14.1
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.28,
    y: 0,
    width: 28.7,
    height: 28.2,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.0285714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 320.63,
    y: 14.1
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 334.98,
    y: 0,
    width: 28.87,
    height: 28.2,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.0285714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 349.415,
    y: 14.1
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 363.85,
    y: 0,
    width: 29.04,
    height: 28.2,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.64
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 378.37,
    y: 14.1
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 392.89,
    y: 0,
    width: 29.23,
    height: 28.2,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 407.505,
    y: 14.1
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 422.12,
    y: 0,
    width: 29.62,
    height: 28.2,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.64
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 436.93,
    y: 14.1
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 451.73,
    y: 0,
    width: 29.68,
    height: 28.2,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 466.57,
    y: 14.1
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 481.41,
    y: 0,
    width: 29.93,
    height: 28.2,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.05
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 496.375,
    y: 14.1
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 511.34,
    y: 0,
    width: 30.35,
    height: 28.2,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.0285714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 526.515,
    y: 14.1
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541.7,
    y: 0,
    width: 30.94,
    height: 28.2,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.64
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 557.1700000000001,
    y: 14.1
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 572.64,
    y: 0,
    width: 30.99,
    height: 28.2,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 588.135,
    y: 14.1
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 603.63,
    y: 0,
    width: 31.28,
    height: 28.2,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 619.27,
    y: 14.1
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 634.91,
    y: 0,
    width: 32.38,
    height: 28.2,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 651.1,
    y: 14.1
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 667.29,
    y: 0,
    width: 32.71,
    height: 28.2,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.0285714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 683.645,
    y: 14.1
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.83,
    y: 28.2,
    width: 32.13,
    height: 28.86,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.886
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.894999999999996,
    y: 42.629999999999995
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.83,
    y: 57.06,
    width: 32.13,
    height: 28.95,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.2375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.894999999999996,
    y: 71.535
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.83,
    y: 86,
    width: 32.13,
    height: 29.01,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.62625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.894999999999996,
    y: 100.505
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.83,
    y: 115.01,
    width: 32.13,
    height: 29.4,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.8999999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.894999999999996,
    y: 129.71
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.83,
    y: 144.41,
    width: 32.13,
    height: 29.7,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.9399999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.894999999999996,
    y: 159.26
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.83,
    y: 174.11,
    width: 32.13,
    height: 29.71,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.942
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.894999999999996,
    y: 188.965
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.83,
    y: 203.83,
    width: 32.13,
    height: 29.88,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.9799999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.894999999999996,
    y: 218.77
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.83,
    y: 233.71,
    width: 32.13,
    height: 30.84,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.894999999999996,
    y: 249.13
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.83,
    y: 264.55,
    width: 32.13,
    height: 31.03,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.103
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.894999999999996,
    y: 280.065
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.83,
    y: 295.59,
    width: 32.13,
    height: 31.46,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.292
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.894999999999996,
    y: 311.32
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.83,
    y: 327.05,
    width: 32.13,
    height: 32.06,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.412000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.894999999999996,
    y: 343.08000000000004
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.83,
    y: 359.11,
    width: 32.13,
    height: 32.67,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.426
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.894999999999996,
    y: 375.445
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.83,
    y: 391.78,
    width: 32.13,
    height: 33.14,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5700000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.894999999999996,
    y: 408.34999999999997
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.83,
    y: 424.92,
    width: 32.13,
    height: 33.41,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.355
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.894999999999996,
    y: 441.625
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.83,
    y: 458.33,
    width: 32.13,
    height: 33.5,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.0325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.894999999999996,
    y: 475.08
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.83,
    y: 491.83,
    width: 32.13,
    height: 34.02,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.426
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.894999999999996,
    y: 508.84
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.83,
    y: 525.85,
    width: 32.13,
    height: 34.49,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.355
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.894999999999996,
    y: 543.095
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.83,
    y: 560.34,
    width: 32.13,
    height: 34.61,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.590000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.894999999999996,
    y: 577.645
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.83,
    y: 594.94,
    width: 32.13,
    height: 34.67,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.426
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.894999999999996,
    y: 612.2750000000001
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.83,
    y: 629.61,
    width: 32.13,
    height: 34.92,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.590000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.894999999999996,
    y: 647.07
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.83,
    y: 664.53,
    width: 32.13,
    height: 35.47,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.590000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.894999999999996,
    y: 682.265
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.96,
    y: 28.2,
    width: 30.87,
    height: 37.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.85875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.395,
    y: 46.849999999999994
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.83,
    y: 28.2,
    width: 31.13,
    height: 37.3,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.1883333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 97.395,
    y: 46.849999999999994
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.96,
    y: 28.2,
    width: 31.5,
    height: 37.3,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.70999999999998,
    y: 46.849999999999994
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.45,
    y: 28.2,
    width: 32.04,
    height: 37.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.577142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 160.47,
    y: 46.849999999999994
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.5,
    y: 28.2,
    width: 32.47,
    height: 37.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.05875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 192.735,
    y: 46.849999999999994
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.96,
    y: 28.2,
    width: 34,
    height: 37.3,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.8
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.96,
    y: 46.849999999999994
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 242.97,
    y: 28.2,
    width: 34.11,
    height: 37.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.685
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 260.025,
    y: 46.849999999999994
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.08,
    y: 28.2,
    width: 36.17,
    height: 37.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.167142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 295.16499999999996,
    y: 46.849999999999994
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 313.24,
    y: 28.2,
    width: 36.54,
    height: 37.3,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.09
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 331.51,
    y: 46.849999999999994
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 349.79,
    y: 28.2,
    width: 37.04,
    height: 37.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.173333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 368.31,
    y: 46.849999999999994
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 386.82,
    y: 28.2,
    width: 37.17,
    height: 37.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.434
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 405.405,
    y: 46.849999999999994
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 424,
    y: 28.2,
    width: 38.26,
    height: 37.3,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.216666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 443.13,
    y: 46.849999999999994
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 462.26,
    y: 28.2,
    width: 38.73,
    height: 37.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.216666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 481.625,
    y: 46.849999999999994
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 500.99,
    y: 28.2,
    width: 39.06,
    height: 37.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.459999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 520.52,
    y: 46.849999999999994
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 540.05,
    y: 28.2,
    width: 39.15,
    height: 37.3,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.6625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 559.625,
    y: 46.849999999999994
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 579.2,
    y: 28.2,
    width: 39.5,
    height: 37.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 598.95,
    y: 46.849999999999994
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 618.7,
    y: 28.2,
    width: 40.39,
    height: 37.3,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.328571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 638.8950000000001,
    y: 46.849999999999994
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 659.09,
    y: 28.2,
    width: 40.91,
    height: 37.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.6625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 679.5450000000001,
    y: 46.849999999999994
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.96,
    y: 65.49,
    width: 39.18,
    height: 38.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.327777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.55,
    y: 84.965
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.96,
    y: 104.45,
    width: 39.18,
    height: 39.42,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.8975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.55,
    y: 124.16
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.96,
    y: 143.87,
    width: 39.18,
    height: 40.97,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.3533333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.55,
    y: 164.35500000000002
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.96,
    y: 184.83,
    width: 39.18,
    height: 41.45,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.8975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.55,
    y: 205.555
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.96,
    y: 226.28,
    width: 39.18,
    height: 41.72,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.918
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.55,
    y: 247.14
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.96,
    y: 268,
    width: 39.18,
    height: 42.42,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.836
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.55,
    y: 289.21
  }, "\n        Peach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.96,
    y: 310.42,
    width: 39.18,
    height: 42.5,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.597142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.55,
    y: 331.67
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.96,
    y: 352.91,
    width: 39.18,
    height: 42.53,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.53
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.55,
    y: 374.175
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.96,
    y: 395.44,
    width: 39.18,
    height: 42.69,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.918
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.55,
    y: 416.78499999999997
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.96,
    y: 438.13,
    width: 39.18,
    height: 43.15,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.53
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.55,
    y: 459.705
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.96,
    y: 481.27,
    width: 39.18,
    height: 43.2,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.836
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.55,
    y: 502.87
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.96,
    y: 524.47,
    width: 39.18,
    height: 43.31,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.836
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.55,
    y: 546.125
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.96,
    y: 567.78,
    width: 39.18,
    height: 43.55,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.836
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.55,
    y: 589.555
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.96,
    y: 611.33,
    width: 39.18,
    height: 44.13,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.836
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.55,
    y: 633.3950000000001
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.96,
    y: 655.47,
    width: 39.18,
    height: 44.53,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.3533333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.55,
    y: 677.735
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.13,
    y: 65.49,
    width: 38.24,
    height: 45.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.25,
    y: 88.33
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.38,
    y: 65.49,
    width: 38.54,
    height: 45.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.505714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 147.65,
    y: 88.33
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.92,
    y: 65.49,
    width: 39.22,
    height: 45.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.536666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 186.52999999999997,
    y: 88.33
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.13,
    y: 65.49,
    width: 40.92,
    height: 45.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.546666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 226.59,
    y: 88.33
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.06,
    y: 65.49,
    width: 41.03,
    height: 45.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.861428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.575,
    y: 88.33
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288.08,
    y: 65.49,
    width: 41.29,
    height: 45.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.881666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 308.72499999999997,
    y: 88.33
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.37,
    y: 65.49,
    width: 41.42,
    height: 45.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.903333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 350.08,
    y: 88.33
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 370.8,
    y: 65.49,
    width: 41.81,
    height: 45.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.972857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 391.70500000000004,
    y: 88.33
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.61,
    y: 65.49,
    width: 43.3,
    height: 45.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 434.26,
    y: 88.33
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 455.9,
    y: 65.49,
    width: 45.17,
    height: 45.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.528333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 478.48499999999996,
    y: 88.33
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501.08,
    y: 65.49,
    width: 46.81,
    height: 45.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.136
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 524.485,
    y: 88.33
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 547.88,
    y: 65.49,
    width: 49.39,
    height: 45.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.613333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 572.575,
    y: 88.33
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 597.27,
    y: 65.49,
    width: 50.35,
    height: 45.68,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.613333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 622.4449999999999,
    y: 88.33
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 647.62,
    y: 65.49,
    width: 52.38,
    height: 45.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.71
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 673.8100000000001,
    y: 88.33
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.13,
    y: 111.17,
    width: 51.71,
    height: 46.42,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.605
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 115.985,
    y: 134.38
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.13,
    y: 157.59,
    width: 51.71,
    height: 48.16,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.02
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 115.985,
    y: 181.67000000000002
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.13,
    y: 205.74,
    width: 51.71,
    height: 48.65,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.95
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 115.985,
    y: 230.065
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.13,
    y: 254.4,
    width: 51.71,
    height: 49.1,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.183333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 115.985,
    y: 278.95
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.13,
    y: 303.49,
    width: 51.71,
    height: 51.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.297142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 115.985,
    y: 329.03000000000003
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.13,
    y: 354.57,
    width: 51.71,
    height: 52.1,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.387142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 115.985,
    y: 380.62
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.13,
    y: 406.67,
    width: 51.71,
    height: 53.28,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.9275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 115.985,
    y: 433.31
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.13,
    y: 459.94,
    width: 51.71,
    height: 55.86,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.618333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 115.985,
    y: 487.87
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.13,
    y: 515.8,
    width: 51.71,
    height: 58.69,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.387142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 115.985,
    y: 545.145
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.13,
    y: 574.5,
    width: 51.71,
    height: 62.08,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.618333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 115.985,
    y: 605.54
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.13,
    y: 636.57,
    width: 51.71,
    height: 63.43,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.618333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 115.985,
    y: 668.2850000000001
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.85,
    y: 111.17,
    width: 54.66,
    height: 63.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.808571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 169.18,
    y: 143.115
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.5,
    y: 111.17,
    width: 57.19,
    height: 63.89,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.437999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.095,
    y: 143.115
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 253.69,
    y: 111.17,
    width: 57.94,
    height: 63.89,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.2425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 282.65999999999997,
    y: 143.115
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 311.64,
    y: 111.17,
    width: 58.1,
    height: 63.89,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.2625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 340.69,
    y: 143.115
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 369.74,
    y: 111.17,
    width: 63.13,
    height: 63.89,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.626000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 401.305,
    y: 143.115
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 432.86,
    y: 111.17,
    width: 63.27,
    height: 63.89,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.90875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 464.495,
    y: 143.115
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 496.13,
    y: 111.17,
    width: 66.69,
    height: 63.89,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.127142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 529.475,
    y: 143.115
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 562.82,
    y: 111.17,
    width: 67.97,
    height: 63.89,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.648333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 596.8050000000001,
    y: 143.115
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 630.79,
    y: 111.17,
    width: 69.21,
    height: 63.89,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.98625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 665.395,
    y: 143.115
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.85,
    y: 175.06,
    width: 68.4,
    height: 67,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.571428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.05,
    y: 208.56
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.85,
    y: 242.05,
    width: 68.4,
    height: 67.78,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.682857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.05,
    y: 275.94
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.85,
    y: 309.84,
    width: 68.4,
    height: 68.7,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.771428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.05,
    y: 344.19
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.85,
    y: 378.53,
    width: 68.4,
    height: 69.57,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.6000000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.05,
    y: 413.31499999999994
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.85,
    y: 448.1,
    width: 68.4,
    height: 73.83,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.680000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.05,
    y: 485.01500000000004
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.85,
    y: 521.93,
    width: 68.4,
    height: 87.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.4
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.05,
    y: 565.5799999999999
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.85,
    y: 609.23,
    width: 68.4,
    height: 90.77,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.1
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.05,
    y: 654.615
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210.25,
    y: 175.06,
    width: 69.45,
    height: 93.31,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.921428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 244.975,
    y: 221.715
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279.7,
    y: 175.06,
    width: 71.9,
    height: 93.31,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.38
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 315.65,
    y: 221.715
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 351.6,
    y: 175.06,
    width: 88.21,
    height: 93.31,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.80111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 395.70500000000004,
    y: 221.715
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 439.82,
    y: 175.06,
    width: 128.12,
    height: 93.31,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.33
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 503.88,
    y: 221.715
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 567.93,
    y: 175.06,
    width: 132.07,
    height: 93.31,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.66375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 633.9649999999999,
    y: 221.715
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210.25,
    y: 268.37,
    width: 107.7,
    height: 129.67,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 26.925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.1,
    y: 333.205
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210.25,
    y: 398.04,
    width: 107.7,
    height: 130.9,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.4625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.1,
    y: 463.49
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210.25,
    y: 528.93,
    width: 107.7,
    height: 171.07,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.385714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.1,
    y: 614.4649999999999
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.95,
    y: 268.37,
    width: 135.15,
    height: 140.68,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.89375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 385.525,
    y: 338.71000000000004
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453.1,
    y: 268.37,
    width: 246.9,
    height: 140.68,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 35.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 576.5500000000001,
    y: 338.71000000000004
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.95,
    y: 409.05,
    width: 172.67,
    height: 290.95,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 28.778333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 404.28499999999997,
    y: 554.525
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 490.62,
    y: 409.05,
    width: 209.38,
    height: 290.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 34.89666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 595.31,
    y: 554.525
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1984);
export default __webpack_public_path__ + "static/media/1984.6c23299b1176479897e69fc1a60b693b.svg";
export { ForwardRef as ReactComponent };